<template>
  <transition name="modal" @enter="enter" @leave="leave">
    <div class="c-modal" tabindex="0" :style="{ zIndex: 9990 + modal.id }" @keyup.esc.stop="close">
      <div class="c-modal__container">
        <div class="c-modal__body">
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'ModalBase',
    
    props: {
      modal: {
        type: Object,
        required: true
      }
    },

    methods: {
      enter () {
        if (this.$mq('sm-min')) this.$overlay.add(this.$modal.remove, 9989 + this.modal.id);
      },

      leave () {
        if (this.$mq('sm-min')) this.$overlay.remove();
      },

      close () {
        this.$emit('close');
        this.$modal.remove();
      },
    },

    mounted() {
      this.$el.focus();
    }
  };
</script>


// WEBPACK FOOTER //
// ../../../../resources/assets/js/app/plugins/modals/ModalBase.vue